function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScNavLibrary = function SvgScNavLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.43597 3.18404C1 4.03969 1 5.15979 1 7.4V16.6C1 18.8402 1 19.9603 1.43597 20.816C1.81947 21.5686 2.43139 22.1805 3.18404 22.564C4.03969 23 5.15979 23 7.4 23H16.6C18.8402 23 19.9603 23 20.816 22.564C21.5686 22.1805 22.1805 21.5686 22.564 20.816C23 19.9603 23 18.8402 23 16.6V7.4C23 5.15979 23 4.03969 22.564 3.18404C22.1805 2.43139 21.5686 1.81947 20.816 1.43597C19.9603 1 18.8402 1 16.6 1H7.4C5.15979 1 4.03969 1 3.18404 1.43597C2.43139 1.81947 1.81947 2.43139 1.43597 3.18404ZM10 5V12.5351C9.41165 12.1948 8.72857 12 8 12C5.79086 12 4 13.7909 4 16C4 18.2091 5.79086 20 8 20C10.2091 20 12 18.2091 12 16V5H10ZM8 14C9.10457 14 10 14.8954 10 16C10 17.1046 9.10457 18 8 18C6.89543 18 6 17.1046 6 16C6 14.8954 6.89543 14 8 14ZM14 7H19V5H14V7ZM14 10H19V8H14V10ZM14 13H19V11H14V13Z",
    fill: "var(--on-surface)",
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 1
    }
  }));
};
export default SvgScNavLibrary;